import React from 'react';
import { projectOffers } from '../data/content';
import { Reveal } from './showcase/Reveal';
import { BrandButton } from './BrandButton';
export function ProjectMenu() {
  return <section id="what-i-build" aria-labelledby="what-i-build-title" className="border-b border-white/5 bg-ink-800" data-id="element-211" data-mp="3a8wab7293y9e">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-212" data-mp="368lwj887w3jz">
        <Reveal data-id="element-213" data-mp="2ih84l3dza9zj">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-214" data-mp="2iiriwog2qayo">
            The project menu
          </p>
          <h2 id="what-i-build-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-215" data-mp="2dkho4ey9hcdl">
            What I build.
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/60" data-id="element-216" data-mp="6s75bpibgwlu">
            Start with the audit. Everything after it is scoped to what your team is
            actually leaking.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-217" data-mp="yr4mbp7s8zrg">
          {projectOffers.map((offer, index) => <li key={offer.name} className="h-full" data-id="element-218" data-mp="12qwyebwdxo1k" data-mpi={index}>
              <Reveal delay={0.06 * index} className="h-full" data-id="element-219" data-mp="12tsxw4nvsks4">
                <div className="flex h-full flex-col rounded-xl border border-white/10 bg-ink-700 p-7" data-id="element-220" data-mp="17rko8u8vnyu7">
                  <h3 className="font-display text-xl font-semibold tracking-tight text-white" data-id="element-221" data-mp="1cpm83he4o26q">
                    {offer.name}
                  </h3>
                  <p className="mt-2 text-sm font-semibold text-brand" data-id="element-222" data-mp="k0xe02bhox4h">{offer.price}</p>
                  <p className="mt-4 text-sm leading-relaxed text-white/60" data-id="element-223" data-mp="p0joi3zxnz9l">
                    {offer.body}
                  </p>
                </div>
              </Reveal>
            </li>)}
        </ul>

        <Reveal className="mt-10" data-id="element-224" data-mp="3shs7ir6ed55w">
          <BrandButton label="Book your free Response Audit" size="lg" withArrow data-id="element-225" data-mp="3sgquih5tm8lj" />
        </Reveal>
      </div>
    </section>;
}